export const ToolData=[
    {
        name:"ReactJS",
        icon:<i class="devicon-react-original colored"></i>,  
    },
    {
        name:"JavaScript",
        icon:<i class="devicon-javascript-plain colored"></i>
    },
    {
        name:"NodeJS",
        icon:<i class="devicon-nodejs-plain-wordmark colored"></i>,
    },
    {
        name:"C#",
        icon:<i class="devicon-csharp-plain colored"></i>,
    },
    {
        name:"C",
        icon:<i class="devicon-c-plain colored"></i>,
    },
    {
        name:"Material UI",
        icon:<i class="devicon-materialui-plain colored"></i>,
    },
    {
        name:"Sass",
        icon:<i class="devicon-sass-original colored"></i>,
    },
    {
        name:"Flutter",
        icon:<i class="devicon-flutter-plain colored"></i>,
    },
    {
        name:"NextJs",
        icon:<i class="devicon-nextjs-original colored"></i>,
    },
    {
        name:"Xcode",
        icon:<i class="devicon-xcode-plain colored"></i>,
    },
    {
        name:"Unity",
        icon:<i class="devicon-unity-original colored"></i>,
    },
    {
        name:"Figma",
        icon:<i class="devicon-figma-plain colored"></i>,
    },
    {
        name:"Adobe Photoshop",
        icon:<i class="devicon-photoshop-plain colored"></i>,
    },
    {
        name:"Adobe Illustrator",
        icon:<i class="devicon-illustrator-plain colored"></i>,
    },
]